import React from "react";
import "./OpticksChip.css";
import classNames from "classnames";

export type ChipVariation =
  | "default"
  | "soft"
  | "neutral"
  | "transparent"
  | "impact-info"
  | "impact-neutral"
  | "impact-success"
  | "impact-warning"
  | "impact-error"
  | "impact-ip-risk"
  | "impact-detection"
  | `impact-detection-${number}`
  | "impact-global-intelligence"
  | "impact-manually-excluded"
  | "impact-targeted-intelligence"
  | "impact-traffic-legitimate"
  | "impact-traffic-suspicious"
  | "impact-traffic-invalid"
  | "impact-traffic-known-bot"
  | "impact-paid"
  | "impact-organic"
  | `impact-label-${number}`
  | `impact-threat-${number}`;

interface Props {
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  label?: React.ReactNode;
  variation?: ChipVariation;
  action?: React.ReactNode;
  size?: "xxs" | "xs" | "s" | "m" | "l";
  weight?: "normal" | "bold";
  /** Render as a `span` where a `div` isn't allowed, e.g. inside a `<button>`. */
  as?: "div" | "span";
}

const OpticksChip = ({
  onClick,
  label = "",
  variation = "default",
  action,
  size = "m",
  weight,
  as: Element = "div",
}: Props) => {
  const resolvedWeight =
    weight ?? (variation?.startsWith("impact") ? "bold" : "normal");

  return (
    <Element
      className={classNames(
        "opticks-chip",
        [`variation-${variation}`],
        [`size-${size}`],
        [`weight-${resolvedWeight}`],
        onClick && "is-clickable"
      )}
      onClick={onClick}
    >
      <span className="label">{label}</span>
      {action && <span className="action">{action}</span>}
    </Element>
  );
};

export default OpticksChip;
